<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Visa Details</v-toolbar-title>
    </v-toolbar>
    <div v-if="project" class="pa-4">
      <v-layout row wrap>
        <v-flex md3>
          <strong>Project Owner </strong><br />
          <p>{{ valueToText(PROJECT_OWNER, project.project_owner)  }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Visa number</strong><br />
          <p>{{ visa && visa.visa_no}}</p>
        </v-flex>
        <v-flex md3>
          <strong>MOFA date</strong><br />
          <p>{{ project.mofa_date}}</p>
        </v-flex>
        <v-flex md3>
          <strong>MOFA Number</strong><br />
          <p>{{ project.mofa_number}}</p>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md3>
          <strong>Trade name </strong><br />
          <p>{{ trade.name }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Embassy Submit date</strong><br />
          <p>{{ project.embassy_submit_date}}</p>
        </v-flex>
        <v-flex md3>
          <strong>Remark</strong><br />
          <p>{{ project.mofa_notes}}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  MEDICAL_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
} from "../../mdsir/const";

import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["project", "visa", "trade"],
  data() {
    return {
      PROJECT_OWNER: PROJECT_OWNER
    };
  },

  // computed: {},

  methods: {
    renderProp(item) {
      const { key } = item;
      let value = this.project[key];
      switch (key) {
        case "medical_status":
          value = value ? valueToText(MEDICAL_STATUSES, value) : "";
          break;
        case "service_type":
          value = value ? valueToText(SERVICE_TYPES, value) : "";
          break;
        case "trade_name":
          value = value ? valueToText(VISA_TYPES, value) : "";
          break;
        case "project_owner":
          value = value ? valueToText(PROJECT_OWNER, value) : "";
          break;

        default:
          break;
      }
      return value;
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
